import { AnyAction } from 'redux'
import { SearchItem } from '../../components/Search'
import {
  getSupplierId,
  isResponseCodeSuccess,
  resetObj,
  mergePlatformList,
} from '../../tools/util'
import { useReducer, useEffect, useRef } from 'react'
import { history, useTypedSelector } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { userRouter } from '../../route'
import {
  EXPORT_NORMAL_PRODUCT,
  GET_PRODUCTCHILDLIST,
} from '../../api/MaterialApi'
import { GET_CHECK_REPORT_TYPE } from '../../api/reportApi'
import { setModuleDataAction } from '../../modules/pagecache'
import { selectNodeParam } from '../../components/TreeAll'
import { Form, message } from 'antd'
import { useUserInfoLimit } from '@/hooks/limit'
import { materialTypeEnum } from '@/global/enum/product'
import { PlatformField } from '@/modules/goodsdetailmodules/reducer'

// action 类型定义
const GOODSLIST_ACTION_TYPE = {
  GET_DATA: 'GOODS/GET_Data', // 获取列表数据
  SET_DATA: 'GOODS/SET_Data', // 设置列表数据
  SEARCH_DATA: 'GOODS/Search_Data', // 搜索数据
  CHANGE_PAGES: 'GOODS/Change_Pages', // 分页
  LOADING: 'GOODS/Loading', //
  CHECKED_DATA: 'GOODS/checked_data_good', //
  CHANGE_SELECT_LEVEL: 'GOODS/change_select_level_good', // 改变选中的类目层级
  RESETSTATE: 'GOODS/resetState_good', // 重置搜索框
  UPLOADFILE_PRICE: 'GOODS/uploadfile_price', // 上传 价格文件
  SET_SEARCHVALUE: 'GOODS/searchValue', // 设置搜索值
  SET_TREEVIS: 'GOODS/SET_treevis', // 显示隐藏tree
  CHANGE_DATA: 'GOODS/CHANGE_DATA', // 替换所有状态
  SET_SUBMISSION_VISIBLE: 'GOODS/SET_SUBMISSION_VISIBLE', // 设置单条提报弹窗
  SET_SUBMISSION_LOADING: 'GOODS/SET_SUBMISSION_LOADING', // 设置单条提报loading
  SET_FILTERED_PLATFORM_LIST: 'GOODS/SET_FILTERED_PLATFORM_LIST', // 设置过滤后的平台列表
  SET_SORT_PARAMS: 'GOODS/SET_SORT_PARAMS', // 设置排序参数
}
// 当前状态接口
interface GoodslistState {
  dataSource: { data: any[]; total: number; loading: boolean }
  searchdata: any
  pages: {
    pageNo: number
    pageSize: number
  }
  checkedData: any[]
  selectData: {
    categoryId: string
    title: string
    level: string
    parentId?: string
    canAddProduct?: boolean
  } // 选中的层级
  searchState: boolean // 搜索表单状态
  searchValue?: string // tree 搜索
  treevisible: boolean
  submissionVisible: boolean
  submissionLoading: boolean
  filteredPlatformList: PlatformField[]
  sortParams: {
    firstPassTimeSortType?: string // 咸亨上架时间排序类型 asc/desc
    submitTimeSortType?: string // 物料提交时间排序类型 asc/desc
  }
}

// 默认数据
const defaultState: GoodslistState = {
  // 表格数据 总条数
  dataSource: { data: [], total: 100, loading: true },
  // 初始化搜索条件
  searchdata: {},
  // 初始化分页
  pages: {
    pageNo: 1,
    pageSize: 25,
  },
  checkedData: [],
  selectData: {
    categoryId: '',
    title: '商品类目顶层',
    level: '',
  },
  searchState: true,
  searchValue: '',
  treevisible: false,
  submissionVisible: false,
  submissionLoading: false,
  filteredPlatformList: [],
  sortParams: {},
}
// 默认 Reducer
const reducer = (state = defaultState, action: AnyAction) => {
  let arr = { ...state }
  switch (action.type) {
    // 初始化数据
    case GOODSLIST_ACTION_TYPE.GET_DATA:
      arr.pages.pageNo = 1
      arr.pages.pageSize = 25
      arr.searchState = !arr.searchState
      arr.searchdata = resetObj(arr.searchdata)
      arr.selectData = {
        categoryId: '',
        title: '商品类目顶层',
        level: '',
        parentId: '',
      }
      arr.checkedData = []
      return arr
    case GOODSLIST_ACTION_TYPE.SET_DATA:
      arr.dataSource = action.value.dataSource
      arr.pages.pageNo = action.value.pageNo
      return arr
    case GOODSLIST_ACTION_TYPE.SEARCH_DATA:
      // 搜索 重置 分页
      arr.searchdata = action.value
      arr.pages.pageNo = 1
      return arr
    case GOODSLIST_ACTION_TYPE.CHANGE_PAGES:
      arr.pages = action.value
      return arr
    // 列表选中项
    case GOODSLIST_ACTION_TYPE.CHECKED_DATA:
      arr.checkedData = action.value
      return arr
    // 类目层级选中项
    case GOODSLIST_ACTION_TYPE.CHANGE_SELECT_LEVEL:
      arr.selectData = action.value
      return arr
    case GOODSLIST_ACTION_TYPE.LOADING:
      arr.dataSource.loading = action.value
      return arr
    case GOODSLIST_ACTION_TYPE.RESETSTATE:
      arr.searchState = !arr.searchState
      arr.searchdata = resetObj(arr.searchdata)
      arr.pages.pageNo = 1
      arr.pages.pageSize = 25
      return arr
    case GOODSLIST_ACTION_TYPE.SET_SEARCHVALUE:
      arr.searchValue = action.value
      return arr
    case GOODSLIST_ACTION_TYPE.SET_TREEVIS:
      arr.treevisible = action.value
      return arr
    case GOODSLIST_ACTION_TYPE.CHANGE_DATA:
      arr = action.value
      return arr
    case GOODSLIST_ACTION_TYPE.SET_SUBMISSION_VISIBLE:
      arr.submissionVisible = action.value
      return arr
    case GOODSLIST_ACTION_TYPE.SET_SUBMISSION_LOADING:
      arr.submissionLoading = action.value
      return arr
    case GOODSLIST_ACTION_TYPE.SET_FILTERED_PLATFORM_LIST:
      arr.filteredPlatformList = action.value
      return arr
    case GOODSLIST_ACTION_TYPE.SET_SORT_PARAMS:
      arr.sortParams = action.value
      return arr
    default:
      return state
  }
}
// Action Creators
// 获取数据
const getdataAction = () => ({ type: GOODSLIST_ACTION_TYPE.GET_DATA })

// 设置数据
const setdataAction = (param: {
  dataSource: { data: any[]; total: number; loading: boolean }
  pageNo: number
}) => ({
  type: GOODSLIST_ACTION_TYPE.SET_DATA,
  value: param,
})
// 切换分页
const changepageAction = (param: { pageNo: number; pageSize?: number }) => ({
  type: GOODSLIST_ACTION_TYPE.CHANGE_PAGES,
  value: param,
})
// 搜索
const changesearchdataAction = (param: SearchItem) => ({
  type: GOODSLIST_ACTION_TYPE.SEARCH_DATA,
  value: param,
})
// loading
const changeloadingAction = (param: boolean) => ({
  type: GOODSLIST_ACTION_TYPE.LOADING,
  value: param,
})
// 选中项
const checkedAction = (param: any[]) => ({
  type: GOODSLIST_ACTION_TYPE.CHECKED_DATA,
  value: param,
})

// 改变选中的类目层级
const changelevelAction = (param: {
  categoryId: string
  title: string
  level: string
  parentId?: string
  canAddProduct?: boolean
}) => ({
  type: GOODSLIST_ACTION_TYPE.CHANGE_SELECT_LEVEL,
  value: param,
})

// 重置搜索条件
const resetsearchAction = () => ({
  type: GOODSLIST_ACTION_TYPE.RESETSTATE,
})

// 记录搜索tree
const setSearchValueAction = (params?: string) => ({
  type: GOODSLIST_ACTION_TYPE.SET_SEARCHVALUE,
  value: params,
})

// 显示隐藏树
const treeVisChangection = (param: boolean) => ({
  type: GOODSLIST_ACTION_TYPE.SET_TREEVIS,
  value: param,
})

const changedataAction = (param: GoodslistState) => ({
  type: GOODSLIST_ACTION_TYPE.CHANGE_DATA,
  value: param,
})

const setSubmissionVisibleAction = (param: boolean) => ({
  type: GOODSLIST_ACTION_TYPE.SET_SUBMISSION_VISIBLE,
  value: param,
})

const setSubmissionLoadingAction = (param: boolean) => ({
  type: GOODSLIST_ACTION_TYPE.SET_SUBMISSION_LOADING,
  value: param,
})

const setFilteredPlatformListAction = (param: PlatformField[]) => ({
  type: GOODSLIST_ACTION_TYPE.SET_FILTERED_PLATFORM_LIST,
  value: param,
})

const setSortParamsAction = (param: {
  firstPassTimeSortType?: string
  submitTimeSortType?: string
}) => ({
  type: GOODSLIST_ACTION_TYPE.SET_SORT_PARAMS,
  value: param,
})
const useGoodslistHook = () => {
  const [state, dispatch] = useReducer(reducer, defaultState)
  const {
    dataSource,
    pages,
    selectData,
    searchState,
    checkedData,
    searchdata,
    searchValue,
    treevisible,
    submissionVisible,
    submissionLoading,
    filteredPlatformList,
    sortParams,
  } = state

  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const { platformList, connectedProjectData } = useTypedSelector(
    (state) => state.goodsReducer,
  )
  const dispatchredux = useDispatch()
  const supRoute = userRouter[1].url
  // 控制异步请求标识
  const ignore = useRef(false)
  const [submissionForm] = Form.useForm()

  const { limitSrmProductType } = useUserInfoLimit()
  useEffect(() => {
    const flag = getpagecache()
    if (flag) {
      const action = changedataAction(flag)
      dispatch(action)
    } else {
      const action = getdataAction()
      dispatch(action)
      getdata(state)
    }
    return () => {
      // eslint-disable-next-line
      ignore.current = true
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: state,
    })
    dispatchredux(action)
    // eslint-disable-next-line
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 获取列表数据
  const getdata = async (goodslist: GoodslistState) => {
    const params = {
      ...goodslist.pages,
      ...goodslist.searchdata,
      ...goodslist.selectData,
      ...goodslist.sortParams,
    }
    // 添加loading
    dispatch(changeloadingAction(true))
    const res = await GET_PRODUCTCHILDLIST({
      code: params.code, // 编码
      name: params.name, // 名称
      categoryId: params.categoryId,
      brand: params.brand, // 品牌
      model: params.model, // 规格型号
      pageSize: params.pageSize, // 分页尺寸
      pageNo: params.pageNo, // 页码
      supplierId: getSupplierId(),
      schemeId: params.schemeId,
      srmProductType: limitSrmProductType(params.srmProductType),
      unitCode: params.unitCode,
      platformCodes: params.platformCodes,
      firstPassStart: params.firstPassStart,
      firstPassEnd: params.firstPassEnd,
      firstPassTimeSortType: params.firstPassTimeSortType,
      submitTimeSortType: params.submitTimeSortType,
      submitTimeStart: params.submitTimeStart,
      submitTimeEnd: params.submitTimeEnd,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resdata = res.data
      const arr = resdata.content.map((item: any) => ({
        ...item,
        ...{ isFreeShipping: item.isFreeShipping === '1' ? '是' : '否' },
        ...{ isDelisting: item.isDelisting === '1' ? '是' : '否' },
      }))
      const count = resdata.totalCount
      const action = setdataAction({
        dataSource: { data: arr, total: count, loading: false },
        pageNo: resdata.pageNo,
      })
      if (!ignore.current) {
        dispatch(action)
      }
    } else {
      dispatch(changeloadingAction(false))
    }
  }

  // 搜索
  const onSearch = (params: SearchItem) => {
    const action = changesearchdataAction(params)
    dispatch(action)
    getdata({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 刷新
  const onRefresh = () => {
    getdata(state)
  }

  // 分页
  const onChange = (pageNo: number, pageSize?: number) => {
    const finalPageSize = pageSize || pages.pageSize || 25
    const action = changepageAction({
      pageNo: pageNo,
      pageSize: finalPageSize,
    })
    // 取消选中项
    dispatch(checkedAction([]))
    dispatch(action)
    getdata({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: finalPageSize,
        },
      },
    })
  }

  // 选中复选框
  const onChangeCheck = (e: any, all: any[]) => {
    const action = checkedAction(all)
    dispatch(action)
  }

  // 点击物料
  const onhandlDetail = (record: any) => {
    history.replace({
      pathname: `${supRoute}/editgoods`,
      state: {
        tempCode: record.code,
        BtnState: ['Edit'],
        auditSource: 'SRM_UPDATE', // 审核来源：SCP修改物料
      },
    })
  }

  // 新增
  const onAddgoods = () => {
    const url = supRoute + '/addgoods'
    history.replace({
      pathname: url,
      state: {
        BtnState: ['Edit', 'Add'],
        childId: null,
        tempId: null,
        auditSource: 'SRM_SECOND_ADD', // 审核来源：SCP新增物料
      },
    })
  }

  // 选中类目层级
  const selectNode = (info: selectNodeParam) => {
    const param = {
      categoryId: info.key,
      title: info.title,
      level: info.level,
      parentId: info.parentId,
      canAddProduct: info.canAddProduct,
    }
    // 存选中类目层级
    dispatch(changelevelAction(param))
    // 重置搜索、分页数据
    dispatch(resetsearchAction())
    getdata({
      ...state,
      ...{
        searchdata: {},
        selectData: param,
      },
    })
  }

  // tree搜索
  const onSearchMod = (e: string) => {
    const action = setSearchValueAction(e)
    dispatch(action)
  }

  // 改变类目显示隐藏
  const onChangetree = () => {
    const action = treeVisChangection(!treevisible)
    dispatch(action)
  }
  const jumpBatchImport = () => {
    history.push('/srm/newBatchAdd')
  }

  // 导出物料明细
  const exportGoodsDetail = async () => {
    let params: any = {}
    // 存在选中项则只导出选中项
    if (checkedData.length) {
      params.codeList = checkedData.map((item) => item.code).join(',')
      // 按照当前搜索参数导出数据
    } else if (Object.keys(searchdata).length) {
      params = {
        ...searchdata,
        firstPassTimeSortType: sortParams.firstPassTimeSortType,
        submitTimeSortType: sortParams.submitTimeSortType,
      }
    }
    const res = await EXPORT_NORMAL_PRODUCT(params)
    if (isResponseCodeSuccess(res.code)) {
      message.success('已转移至任务中心执行')
    }
  }

  // 修改搜索条件时，置空选中项
  useEffect(() => {
    dispatch(checkedAction([]))
  }, [searchdata])

  const handleGoodsSubmission = () => {
    if (checkedData.length) {
      if (checkedData.length === 1) {
        dispatch(setSubmissionVisibleAction(true))
      } else {
        message.warning('功能只能支持单一商品进行提报')
      }

      if (
        materialTypeEnum.isLabelsMatchValue(
          ['供应商物料'],
          checkedData[0].srmProductType,
        )
      ) {
        const filteredPlatformList = mergePlatformList(
          connectedProjectData,
          platformList,
        )
        dispatch(setFilteredPlatformListAction(filteredPlatformList))
      } else {
        dispatch(setFilteredPlatformListAction(platformList))
      }
    } else {
      message.warning('请先选中物料')
    }
  }
  const handleGoodsSubmissionCancel = () => {
    submissionForm.resetFields()
    dispatch(setSubmissionVisibleAction(false))
    dispatch(setSubmissionLoadingAction(false))
  }
  const handleGoodsSubmissionSubmit = async () => {
    const form = await submissionForm.validateFields()
    dispatch(setSubmissionLoadingAction(true))
    const showDiscountRate =
      platformList.find((item) => item.code === form.platformCode)
        ?.showDiscountRate ?? '0'

    const res = await GET_CHECK_REPORT_TYPE({
      platformCode: form.platformCode,
      productCode: checkedData[0].code,
      reportType: form.submissionType,
    })
    if (res.code === 0 && res.data) {
      dispatch(setSubmissionLoadingAction(false))
      dispatch(setSubmissionVisibleAction(false))
      history.replace({
        pathname: `${supRoute}/goodsSubmissionEdit`,
        state: {
          id: checkedData[0].mdmId,
          BtnState: ['Edit'],
          platformCode: form.platformCode,
          platformName: form.platformName,
          submissionType: form.submissionType,
          isSingleSubmission: true, // 是否为单条提报入口进入
          productCode: checkedData[0].code,
          showDiscountRate,
        },
      })
    }
    dispatch(setSubmissionLoadingAction(false))
  }

  // 处理排序变化
  const onSortChange = (
    sortField: 'firstPassTime' | 'submitTime',
    sortOrder: 'ascend' | 'descend' | null,
  ) => {
    const newSortParams: {
      firstPassTimeSortType?: string
      submitTimeSortType?: string
    } = {}

    if (sortField === 'firstPassTime') {
      if (sortOrder) {
        newSortParams.firstPassTimeSortType =
          sortOrder === 'ascend' ? 'asc' : 'desc'
      }
    } else if (sortField === 'submitTime') {
      if (sortOrder) {
        newSortParams.submitTimeSortType =
          sortOrder === 'ascend' ? 'asc' : 'desc'
      }
    }

    dispatch(setSortParamsAction(newSortParams))
    // 重置到第一页并重新获取数据
    const action = changepageAction({ pageNo: 1 })
    dispatch(action)
    getdata({
      ...state,
      ...{
        sortParams: newSortParams,
        pages: {
          pageNo: 1,
          pageSize: pages.pageSize,
        },
      },
    })
  }

  return {
    dataSource,
    pages,
    selectData,
    searchState,
    checkedData,
    searchdata,
    searchValue,
    treevisible,
    submissionVisible,
    filteredPlatformList,
    submissionLoading,
    submissionForm,
    sortParams,
    onSearch,
    onChange,
    onChangeCheck,
    onhandlDetail,
    onAddgoods,
    selectNode,
    onSearchMod,
    onRefresh,
    onChangetree,
    jumpBatchImport,
    exportGoodsDetail,
    handleGoodsSubmission,
    handleGoodsSubmissionCancel,
    handleGoodsSubmissionSubmit,
    onSortChange,
  }
}

export default useGoodslistHook
import { AnyAction } from 'redux'
import { SearchItem } from '../../components/Search'
import {
  getSupplierId,
  isResponseCodeSuccess,
  resetObj,
  mergePlatformList,
} from '../../tools/util'
import { useReducer, useEffect, useRef } from 'react'
import { history, useTypedSelector } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { userRouter } from '../../route'
import {
  EXPORT_NORMAL_PRODUCT,
  GET_PRODUCTCHILDLIST,
} from '../../api/MaterialApi'
import { GET_CHECK_REPORT_TYPE } from '../../api/reportApi'
import { setModuleDataAction } from '../../modules/pagecache'
import { selectNodeParam } from '../../components/TreeAll'
import { Form, message } from 'antd'
import { useUserInfoLimit } from '@/hooks/limit'
import { materialTypeEnum } from '@/global/enum/product'
import { PlatformField } from '@/modules/goodsdetailmodules/reducer'

// action 类型定义
const GOODSLIST_ACTION_TYPE = {
  GET_DATA: 'GOODS/GET_Data', // 获取列表数据
  SET_DATA: 'GOODS/SET_Data', // 设置列表数据
  SEARCH_DATA: 'GOODS/Search_Data', // 搜索数据
  CHANGE_PAGES: 'GOODS/Change_Pages', // 分页
  LOADING: 'GOODS/Loading', //
  CHECKED_DATA: 'GOODS/checked_data_good', //
  CHANGE_SELECT_LEVEL: 'GOODS/change_select_level_good', // 改变选中的类目层级
  RESETSTATE: 'GOODS/resetState_good', // 重置搜索框
  UPLOADFILE_PRICE: 'GOODS/uploadfile_price', // 上传 价格文件
  SET_SEARCHVALUE: 'GOODS/searchValue', // 设置搜索值
  SET_TREEVIS: 'GOODS/SET_treevis', // 显示隐藏tree
  CHANGE_DATA: 'GOODS/CHANGE_DATA', // 替换所有状态
  SET_SUBMISSION_VISIBLE: 'GOODS/SET_SUBMISSION_VISIBLE', // 设置单条提报弹窗
  SET_SUBMISSION_LOADING: 'GOODS/SET_SUBMISSION_LOADING', // 设置单条提报loading
  SET_FILTERED_PLATFORM_LIST: 'GOODS/SET_FILTERED_PLATFORM_LIST', // 设置过滤后的平台列表
  SET_SORT_PARAMS: 'GOODS/SET_SORT_PARAMS', // 设置排序参数
}
// 当前状态接口
interface GoodslistState {
  dataSource: { data: any[]; total: number; loading: boolean }
  searchdata: any
  pages: {
    pageNo: number
    pageSize: number
  }
  checkedData: any[]
  selectData: {
    categoryId: string
    title: string
    level: string
    parentId?: string
    canAddProduct?: boolean
  } // 选中的层级
  searchState: boolean // 搜索表单状态
  searchValue?: string // tree 搜索
  treevisible: boolean
  submissionVisible: boolean
  submissionLoading: boolean
  filteredPlatformList: PlatformField[]
  sortParams: {
    firstPassTimeSortType?: string // 咸亨上架时间排序类型 asc/desc
    submitTimeSortType?: string // 物料提交时间排序类型 asc/desc
  }
}

// 默认数据
const defaultState: GoodslistState = {
  // 表格数据 总条数
  dataSource: { data: [], total: 100, loading: true },
  // 初始化搜索条件
  searchdata: {},
  // 初始化分页
  pages: {
    pageNo: 1,
    pageSize: 25,
  },
  checkedData: [],
  selectData: {
    categoryId: '',
    title: '商品类目顶层',
    level: '',
  },
  searchState: true,
  searchValue: '',
  treevisible: false,
  submissionVisible: false,
  submissionLoading: false,
  filteredPlatformList: [],
  sortParams: {},
}
// 默认 Reducer
const reducer = (state = defaultState, action: AnyAction) => {
  let arr = { ...state }
  switch (action.type) {
    // 初始化数据
    case GOODSLIST_ACTION_TYPE.GET_DATA:
      arr.pages.pageNo = 1
      arr.pages.pageSize = 25
      arr.searchState = !arr.searchState
      arr.searchdata = resetObj(arr.searchdata)
      arr.selectData = {
        categoryId: '',
        title: '商品类目顶层',
        level: '',
        parentId: '',
      }
      arr.checkedData = []
      return arr
    case GOODSLIST_ACTION_TYPE.SET_DATA:
      arr.dataSource = action.value.dataSource
      arr.pages.pageNo = action.value.pageNo
      return arr
    case GOODSLIST_ACTION_TYPE.SEARCH_DATA:
      // 搜索 重置 分页
      arr.searchdata = action.value
      arr.pages.pageNo = 1
      return arr
    case GOODSLIST_ACTION_TYPE.CHANGE_PAGES:
      arr.pages = action.value
      return arr
    // 列表选中项
    case GOODSLIST_ACTION_TYPE.CHECKED_DATA:
      arr.checkedData = action.value
      return arr
    // 类目层级选中项
    case GOODSLIST_ACTION_TYPE.CHANGE_SELECT_LEVEL:
      arr.selectData = action.value
      return arr
    case GOODSLIST_ACTION_TYPE.LOADING:
      arr.dataSource.loading = action.value
      return arr
    case GOODSLIST_ACTION_TYPE.RESETSTATE:
      arr.searchState = !arr.searchState
      arr.searchdata = resetObj(arr.searchdata)
      arr.pages.pageNo = 1
      arr.pages.pageSize = 25
      return arr
    case GOODSLIST_ACTION_TYPE.SET_SEARCHVALUE:
      arr.searchValue = action.value
      return arr
    case GOODSLIST_ACTION_TYPE.SET_TREEVIS:
      arr.treevisible = action.value
      return arr
    case GOODSLIST_ACTION_TYPE.CHANGE_DATA:
      arr = action.value
      return arr
    case GOODSLIST_ACTION_TYPE.SET_SUBMISSION_VISIBLE:
      arr.submissionVisible = action.value
      return arr
    case GOODSLIST_ACTION_TYPE.SET_SUBMISSION_LOADING:
      arr.submissionLoading = action.value
      return arr
    case GOODSLIST_ACTION_TYPE.SET_FILTERED_PLATFORM_LIST:
      arr.filteredPlatformList = action.value
      return arr
    case GOODSLIST_ACTION_TYPE.SET_SORT_PARAMS:
      arr.sortParams = action.value
      return arr
    default:
      return state
  }
}
// Action Creators
// 获取数据
const getdataAction = () => ({ type: GOODSLIST_ACTION_TYPE.GET_DATA })

// 设置数据
const setdataAction = (param: {
  dataSource: { data: any[]; total: number; loading: boolean }
  pageNo: number
}) => ({
  type: GOODSLIST_ACTION_TYPE.SET_DATA,
  value: param,
})
// 切换分页
const changepageAction = (param: { pageNo: number; pageSize?: number }) => ({
  type: GOODSLIST_ACTION_TYPE.CHANGE_PAGES,
  value: param,
})
// 搜索
const changesearchdataAction = (param: SearchItem) => ({
  type: GOODSLIST_ACTION_TYPE.SEARCH_DATA,
  value: param,
})
// loading
const changeloadingAction = (param: boolean) => ({
  type: GOODSLIST_ACTION_TYPE.LOADING,
  value: param,
})
// 选中项
const checkedAction = (param: any[]) => ({
  type: GOODSLIST_ACTION_TYPE.CHECKED_DATA,
  value: param,
})

// 改变选中的类目层级
const changelevelAction = (param: {
  categoryId: string
  title: string
  level: string
  parentId?: string
  canAddProduct?: boolean
}) => ({
  type: GOODSLIST_ACTION_TYPE.CHANGE_SELECT_LEVEL,
  value: param,
})

// 重置搜索条件
const resetsearchAction = () => ({
  type: GOODSLIST_ACTION_TYPE.RESETSTATE,
})

// 记录搜索tree
const setSearchValueAction = (params?: string) => ({
  type: GOODSLIST_ACTION_TYPE.SET_SEARCHVALUE,
  value: params,
})

// 显示隐藏树
const treeVisChangection = (param: boolean) => ({
  type: GOODSLIST_ACTION_TYPE.SET_TREEVIS,
  value: param,
})

const changedataAction = (param: GoodslistState) => ({
  type: GOODSLIST_ACTION_TYPE.CHANGE_DATA,
  value: param,
})

const setSubmissionVisibleAction = (param: boolean) => ({
  type: GOODSLIST_ACTION_TYPE.SET_SUBMISSION_VISIBLE,
  value: param,
})

const setSubmissionLoadingAction = (param: boolean) => ({
  type: GOODSLIST_ACTION_TYPE.SET_SUBMISSION_LOADING,
  value: param,
})

const setFilteredPlatformListAction = (param: PlatformField[]) => ({
  type: GOODSLIST_ACTION_TYPE.SET_FILTERED_PLATFORM_LIST,
  value: param,
})

const setSortParamsAction = (param: {
  firstPassTimeSortType?: string
  submitTimeSortType?: string
}) => ({
  type: GOODSLIST_ACTION_TYPE.SET_SORT_PARAMS,
  value: param,
})
const useGoodslistHook = () => {
  const [state, dispatch] = useReducer(reducer, defaultState)
  const {
    dataSource,
    pages,
    selectData,
    searchState,
    checkedData,
    searchdata,
    searchValue,
    treevisible,
    submissionVisible,
    submissionLoading,
    filteredPlatformList,
    sortParams,
  } = state

  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const { platformList, connectedProjectData } = useTypedSelector(
    (state) => state.goodsReducer,
  )
  const dispatchredux = useDispatch()
  const supRoute = userRouter[1].url
  // 控制异步请求标识
  const ignore = useRef(false)
  const [submissionForm] = Form.useForm()

  const { limitSrmProductType } = useUserInfoLimit()
  useEffect(() => {
    const flag = getpagecache()
    if (flag) {
      const action = changedataAction(flag)
      dispatch(action)
    } else {
      const action = getdataAction()
      dispatch(action)
      getdata(state)
    }
    return () => {
      // eslint-disable-next-line
      ignore.current = true
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: state,
    })
    dispatchredux(action)
    // eslint-disable-next-line
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 获取列表数据
  const getdata = async (goodslist: GoodslistState) => {
    const params = {
      ...goodslist.pages,
      ...goodslist.searchdata,
      ...goodslist.selectData,
      ...goodslist.sortParams,
    }
    // 添加loading
    dispatch(changeloadingAction(true))
    const res = await GET_PRODUCTCHILDLIST({
      code: params.code, // 编码
      name: params.name, // 名称
      categoryId: params.categoryId,
      brand: params.brand, // 品牌
      model: params.model, // 规格型号
      pageSize: params.pageSize, // 分页尺寸
      pageNo: params.pageNo, // 页码
      supplierId: getSupplierId(),
      schemeId: params.schemeId,
      srmProductType: limitSrmProductType(params.srmProductType),
      unitCode: params.unitCode,
      platformCodes: params.platformCodes,
      firstPassStart: params.firstPassStart,
      firstPassEnd: params.firstPassEnd,
      firstPassTimeSortType: params.firstPassTimeSortType,
      submitTimeSortType: params.submitTimeSortType,
      submitTimeStart: params.submitTimeStart,
      submitTimeEnd: params.submitTimeEnd,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resdata = res.data
      const arr = resdata.content.map((item: any) => ({
        ...item,
        ...{ isFreeShipping: item.isFreeShipping === '1' ? '是' : '否' },
        ...{ isDelisting: item.isDelisting === '1' ? '是' : '否' },
      }))
      const count = resdata.totalCount
      const action = setdataAction({
        dataSource: { data: arr, total: count, loading: false },
        pageNo: resdata.pageNo,
      })
      if (!ignore.current) {
        dispatch(action)
      }
    } else {
      dispatch(changeloadingAction(false))
    }
  }

  // 搜索
  const onSearch = (params: SearchItem) => {
    const action = changesearchdataAction(params)
    dispatch(action)
    getdata({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 刷新
  const onRefresh = () => {
    getdata(state)
  }

  // 分页
  const onChange = (pageNo: number, pageSize?: number) => {
    const finalPageSize = pageSize || pages.pageSize || 25
    const action = changepageAction({
      pageNo: pageNo,
      pageSize: finalPageSize,
    })
    // 取消选中项
    dispatch(checkedAction([]))
    dispatch(action)
    getdata({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: finalPageSize,
        },
      },
    })
  }

  // 选中复选框
  const onChangeCheck = (e: any, all: any[]) => {
    const action = checkedAction(all)
    dispatch(action)
  }

  // 点击物料
  const onhandlDetail = (record: any) => {
    history.replace({
      pathname: `${supRoute}/editgoods`,
      state: {
        tempCode: record.code,
        BtnState: ['Edit'],
        auditSource: 'SRM_UPDATE', // 审核来源：SCP修改物料
      },
    })
  }

  // 新增
  const onAddgoods = () => {
    const url = supRoute + '/addgoods'
    history.replace({
      pathname: url,
      state: {
        BtnState: ['Edit', 'Add'],
        childId: null,
        tempId: null,
        auditSource: 'SRM_SECOND_ADD', // 审核来源：SCP新增物料
      },
    })
  }

  // 选中类目层级
  const selectNode = (info: selectNodeParam) => {
    const param = {
      categoryId: info.key,
      title: info.title,
      level: info.level,
      parentId: info.parentId,
      canAddProduct: info.canAddProduct,
    }
    // 存选中类目层级
    dispatch(changelevelAction(param))
    // 重置搜索、分页数据
    dispatch(resetsearchAction())
    getdata({
      ...state,
      ...{
        searchdata: {},
        selectData: param,
      },
    })
  }

  // tree搜索
  const onSearchMod = (e: string) => {
    const action = setSearchValueAction(e)
    dispatch(action)
  }

  // 改变类目显示隐藏
  const onChangetree = () => {
    const action = treeVisChangection(!treevisible)
    dispatch(action)
  }
  const jumpBatchImport = () => {
    history.push('/srm/newBatchAdd')
  }

  // 导出物料明细
  const exportGoodsDetail = async () => {
    let params: any = {}
    // 存在选中项则只导出选中项
    if (checkedData.length) {
      params.codeList = checkedData.map((item) => item.code).join(',')
      // 按照当前搜索参数导出数据
    } else if (Object.keys(searchdata).length) {
      params = {
        ...searchdata,
        firstPassTimeSortType: sortParams.firstPassTimeSortType,
        submitTimeSortType: sortParams.submitTimeSortType,
      }
    }
    const res = await EXPORT_NORMAL_PRODUCT(params)
    if (isResponseCodeSuccess(res.code)) {
      message.success('已转移至任务中心执行')
    }
  }

  // 修改搜索条件时，置空选中项
  useEffect(() => {
    dispatch(checkedAction([]))
  }, [searchdata])

  const handleGoodsSubmission = () => {
    if (checkedData.length) {
      if (checkedData.length === 1) {
        dispatch(setSubmissionVisibleAction(true))
      } else {
        message.warning('功能只能支持单一商品进行提报')
      }

      if (
        materialTypeEnum.isLabelsMatchValue(
          ['供应商物料'],
          checkedData[0].srmProductType,
        )
      ) {
        const filteredPlatformList = mergePlatformList(
          connectedProjectData,
          platformList,
        )
        dispatch(setFilteredPlatformListAction(filteredPlatformList))
      } else {
        dispatch(setFilteredPlatformListAction(platformList))
      }
    } else {
      message.warning('请先选中物料')
    }
  }
  const handleGoodsSubmissionCancel = () => {
    submissionForm.resetFields()
    dispatch(setSubmissionVisibleAction(false))
    dispatch(setSubmissionLoadingAction(false))
  }
  const handleGoodsSubmissionSubmit = async () => {
    const form = await submissionForm.validateFields()
    dispatch(setSubmissionLoadingAction(true))
    const showDiscountRate =
      platformList.find((item) => item.code === form.platformCode)
        ?.showDiscountRate ?? '0'

    const res = await GET_CHECK_REPORT_TYPE({
      platformCode: form.platformCode,
      productCode: checkedData[0].code,
      reportType: form.submissionType,
    })
    if (res.code === 0 && res.data) {
      dispatch(setSubmissionLoadingAction(false))
      dispatch(setSubmissionVisibleAction(false))
      history.replace({
        pathname: `${supRoute}/goodsSubmissionEdit`,
        state: {
          id: checkedData[0].mdmId,
          BtnState: ['Edit'],
          platformCode: form.platformCode,
          platformName: form.platformName,
          submissionType: form.submissionType,
          isSingleSubmission: true, // 是否为单条提报入口进入
          productCode: checkedData[0].code,
          showDiscountRate,
        },
      })
    }
    dispatch(setSubmissionLoadingAction(false))
  }

  // 处理排序变化
  const onSortChange = (
    sortField: 'firstPassTime' | 'submitTime',
    sortOrder: 'ascend' | 'descend' | null,
  ) => {
    const newSortParams: {
      firstPassTimeSortType?: string
      submitTimeSortType?: string
    } = {}

    if (sortField === 'firstPassTime') {
      if (sortOrder) {
        newSortParams.firstPassTimeSortType =
          sortOrder === 'ascend' ? 'asc' : 'desc'
      }
    } else if (sortField === 'submitTime') {
      if (sortOrder) {
        newSortParams.submitTimeSortType =
          sortOrder === 'ascend' ? 'asc' : 'desc'
      }
    }

    dispatch(setSortParamsAction(newSortParams))
    // 重置到第一页并重新获取数据
    const action = changepageAction({ pageNo: 1 })
    dispatch(action)
    getdata({
      ...state,
      ...{
        sortParams: newSortParams,
        pages: {
          pageNo: 1,
          pageSize: pages.pageSize,
        },
      },
    })
  }

  return {
    dataSource,
    pages,
    selectData,
    searchState,
    checkedData,
    searchdata,
    searchValue,
    treevisible,
    submissionVisible,
    filteredPlatformList,
    submissionLoading,
    submissionForm,
    sortParams,
    onSearch,
    onChange,
    onChangeCheck,
    onhandlDetail,
    onAddgoods,
    selectNode,
    onSearchMod,
    onRefresh,
    onChangetree,
    jumpBatchImport,
    exportGoodsDetail,
    handleGoodsSubmission,
    handleGoodsSubmissionCancel,
    handleGoodsSubmissionSubmit,
    onSortChange,
  }
}

export default useGoodslistHook
